module.exports = __webpack_public_path__ + "media/St 4-desk lamp-incorrect.7cad2224.wav";